const adressStandList = "https://api.mobo.su/wp-json/api/v1/get-data/";
const adressStands = "https://api.mobo.su//wp-json/api/v1/get-all";
const adressColorsStand = "https://api.mobo.su//wp-json/api/v1/get-color";
const adressSinks = "https://api.mobo.su/wp-json/api/v1/get-sinks";
const adressTabletops = "https://api.mobo.su//wp-json/api/v1/get-countertops";
const adressTabletopsColor = "https://api.mobo.su//wp-json/api/v1/get-kg_colors";
const adressFlapVariation = "https://api.mobo.su//wp-json/api/v1/get-bottom-valves"
const adressFlaps = "https://api.mobo.su//wp-json/api/v1/get-flaps";
const addressDefaultConfig = "https://api.mobo.su//wp-json/api/v1/get-default_config";
const adressMirrors = "https://api.mobo.su/wp-json/api/v1/get-mirrors";
const addressMirrorsList = "https:///api.mobo.su/wp-json/api/v1/get-list_mirrors/";
const adressCabinets = "https:///api.mobo.su/wp-json/api/v1/get-penal_cases/";
const adressCabinetList = "https:///api.mobo.su/wp-json/api/v1/get-penal_table";
const adressSinksId = "https://api.mobo.su/wp-json/api/v1/get-sinks_data";
const adressRender = "https://api.mobo.su/wp-json/api/v1/get-render_interface";
const login = 'dev';
const password = 'nMAx eWRd TQsh vWRy kY4F WJTf';

export {login, password, adressStandList, adressStands, adressColorsStand, adressSinks, adressTabletops, adressTabletopsColor, adressFlapVariation, adressFlaps, addressDefaultConfig, adressMirrors, addressMirrorsList, adressCabinets, adressCabinetList, adressSinksId, adressRender}